/**
 * ICAO Standard Atmosphere (ISA) constants, ISO 2533 / ICAO Doc 7488.
 * All values are SI and exact as defined by the standard.
 */

/** Sea-level standard temperature, K (15 °C). */
export const T0_K = 288.15
/** Sea-level standard pressure, Pa (1013.25 hPa / 29.9213 inHg). */
export const P0_PA = 101325
/** Sea-level standard density, kg/m³. */
export const RHO0_KG_M3 = 1.225
/** Standard gravity, m/s². */
export const G0 = 9.80665
/** Specific gas constant for dry air, J/(kg·K). */
export const R_AIR = 287.05287
/** Specific gas constant for water vapour, J/(kg·K). */
export const R_VAPOUR = 461.495
/** Ratio of specific heats for air (dimensionless). */
export const GAMMA = 1.4
/** Sea-level standard speed of sound, m/s (661.4788 kt). */
export const A0_MS = 340.294

/** Tropospheric lapse rate, K/m (2 °C per 1000 ft, near enough). */
export const LAPSE_K_PER_M = 0.0065
/** Tropopause geopotential altitude, m (36 089 ft). */
export const TROPOPAUSE_M = 11000
/** Temperature above the tropopause and up to 20 km, K (−56.5 °C). */
export const T_TROPOPAUSE_K = 216.65
/** Pressure at the tropopause, Pa. */
export const P_TROPOPAUSE_PA = 22632.06
/** Top of the isothermal layer, m. */
export const STRATO_ISOTHERMAL_TOP_M = 20000
/** Lapse rate from 20 km to 32 km, K/m (temperature *rises*). */
export const LAPSE2_K_PER_M = -0.001

/** Mean radius of the Earth, m — used for great-circle work and geopotential. */
export const EARTH_RADIUS_M = 6371008.8

/** Exponent `g / (L·R)` in the barometric formula. Precomputed: ~5.2559. */
export const BARO_EXPONENT = G0 / (LAPSE_K_PER_M * R_AIR)
